module.exports = __webpack_public_path__ + "img/banner-bg_1.4fafe684.png";